import { Axios } from 'axios'
import { RootState } from '@/store'
import { Kamoku } from '@/repositories/fuzoku-meisai/data'
import { ResponseHojokinSetting, ResponseHojokinSettingItem } from '@/repositories/fuzoku-meisai/junsoku/data'

export interface HojokinRepository {
  list (): Promise<ResponseHojokinSetting>;

  save (param: ResponseHojokinSettingItem[]): Promise<void>;
}

export type PostParamItem = {
  itemName: string;
  type: string;
  issuer: string;
  overview: string;
  incomeSetting: Kamoku[];
  debtSetting: Kamoku[];
}

export class HojokinRepositoryImpl implements HojokinRepository {
  constructor (http: Axios, baseUrl: string, state: RootState) {
    this.http = http
    this.baseUrl = `${baseUrl}/hojokin`
    this.state = state
  }

  private readonly http: Axios

  private readonly baseUrl: string

  private readonly state: RootState

  async list (): Promise<ResponseHojokinSetting> {
    const startDate = this.state.accountingStartDate
    const endDate = this.state.accountingEndDate

    const { data } = await this.http.get(
      this.baseUrl,
      {
        params: {
          startDate: startDate,
          endDate: endDate
        }
      }
    )
    return data
  }

  async save (param: ResponseHojokinSettingItem[]): Promise<void> {
    const postParams: PostParamItem[] = param.map(p => {
      return {
        itemName: p.itemName,
        type: p.type,
        issuer: p.issuer,
        overview: p.overview,
        incomeSetting: p.incomeSetting.targets,
        debtSetting: p.debtSetting.targets
      }
    })
    await this.http.post(this.baseUrl, postParams)
  }
}
